import HttpClient from '../../../services/http-client';
import { IHomeResponse } from '../../../../model/apm/home/response/home-response';
import { IHomeSectionResponse } from '../../../../model/apm/home/response/home-section-response';
import { IHomeSectionItemResponse } from '../../../../model/apm/home/response/home-section-item-response';
import { IHomeSectionAddEditRequest } from '../../../../model/apm/home/request/home-section-add-edit-request';
import { IHomeSectionItemAddEditRequest } from '../../../../model/apm/home/request/home-section-item-add-edit-request';

const defaultPath = 'Home';

const get = async (): Promise<IHomeResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`
    }).then((response) => response.data);
};

const changeStatus = async (isEnabled: boolean): Promise<IHomeResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Status`,
        data: { isEnabled }
    }).then((response) => response.data);
};

const addSection = async (params: IHomeSectionAddEditRequest): Promise<IHomeSectionResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Section`,
        data: params
    }).then((response) => response.data);
};

const editSection = async (sectionId: number, params: IHomeSectionAddEditRequest): Promise<IHomeSectionResponse> => {
    const { type, ...data } = params;
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/${sectionId}`,
        data
    }).then((response) => response.data);
};

const removeSection = async (sectionId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/Section/${sectionId}`
    });
};

const reorderSections = async (ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/Order`,
        data: { ids }
    });
};

const addItem = async (sectionId: number, params: IHomeSectionItemAddEditRequest): Promise<IHomeSectionItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Section/${sectionId}/Item`,
        data: params
    }).then((response) => response.data);
};

const editItem = async (sectionId: number, itemId: number, params: IHomeSectionItemAddEditRequest): Promise<IHomeSectionItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/${sectionId}/Item/${itemId}`,
        data: params
    }).then((response) => response.data);
};

const removeItem = async (sectionId: number, itemId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/Section/${sectionId}/Item/${itemId}`
    });
};

const reorderItems = async (sectionId: number, ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/${sectionId}/Item/Order`,
        data: { ids }
    });
};

const HomeAppService = {
    get, changeStatus,
    addSection, editSection, removeSection, reorderSections,
    addItem, editItem, removeItem, reorderItems
};
export default HomeAppService;
